

import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, TextField } from '@mui/material';
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';

import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { CaseMainInfo, IdCaseMainInfo, LastFetchTimeMainInfo, LoadingMainInfo } from 'entities/insurance-contract/main-info/selector';
import { fetchCase } from 'entities/insurance-contract/main-info/actions/fetch-main-info';

import styles from 'features/insured-person-case/ui/GuaranteeLetter.module.css';
import CustomButton from 'shared/custom-button/CustomButton';
import { isValidIdCase } from 'shared/utils/hooks/useValidationIdCase';
import Loader from 'shared/loader/Loader';
import { useNavigate } from 'react-router-dom';
import { CurrentPageTasksInCase, FileDataGuaranteeLetter, FileNameGuaranteeLetter, GuaranteeLettersList, LastFetchTimeGuaranteeLettersList, LoadingGuaranteeLettersList, PolicyID } from 'entities/guarantee-letter/selector';
import { isEqual } from 'lodash-es';
import { fetchDownloadhGuaranteeLetter, fetchGuaranteeLetters } from 'entities/guarantee-letter/actions/fetch-guarantee-letter';
import { resetFile, setCurrentPageInCaseGuaranteeLetters } from 'entities/guarantee-letter';
import List from 'widgets/list/list';

import appStyles from 'app/providers/theme/App.module.css';

import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EmailIcon from '@mui/icons-material/Email';
import ModalWidget from 'widgets/modal/Modal';
import { useForm } from 'shared/utils/hooks/useForm';
import { validationSchema } from '../utils/validationSchema';
import * as Yup from 'yup';
import { getRequest } from 'shared/utils/fetch-api';

interface IGuaranteeLetter {
    contrsctProgramID: string;
}

const GuaranteeLetter: FC<IGuaranteeLetter> = ({ contrsctProgramID }) => {
    const limit = 10;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const guaranteeLetter = useAppSelector(GuaranteeLettersList);
    const isLoading = useAppSelector(LoadingGuaranteeLettersList);
    const currentPageInCase = useAppSelector(CurrentPageTasksInCase);




    const [isValid, setIsValid] = useState(true);
    const [isUserAction, setIsUserAction] = useState(false);


    const userData = {
        Email: '',
    };

    const {
        formData,
        handleChangeInput,
        errors,
        handleBlurInput,
        setErrors,
        setFormData
    } = useForm(userData, validationSchema);


    useEffect(() => {
        if (contrsctProgramID) {
            dispatch(setCurrentPageInCaseGuaranteeLetters({ page: 1 }));
            dispatch(fetchGuaranteeLetters({ PolicyID: contrsctProgramID }));
        }

    }, [dispatch, PolicyID]);


    useEffect(() => {
        if (isUserAction) {
            dispatch(setCurrentPageInCaseGuaranteeLetters({ page: 1 }));
            setIsUserAction(false);
        }
    }, [isUserAction]);


    const handleChildAction = useCallback((page: number) => {
        dispatch(setCurrentPageInCaseGuaranteeLetters({ page }));
    }, [dispatch]);

    const paginatedData = () => {
        const startIndex = (currentPageInCase - 1) * 10;
        return guaranteeLetter.slice(startIndex, startIndex + 10);
    };

    const [openModal, setOpenModal] = useState(false);


    const [errorSend, setErrorSend] = useState([{ Msg: '' }]);
    const [success, setSuccess] = useState(false);
    const [idSendFile, setIdSendFile] = useState('');
    const [isLoadingSend, setIsLoadingSend] = useState(false);

    const getSendFile = (ID: string) => {
        setErrorSend([{ Msg: '' }]);
        setOpenModal((prevState) => !prevState);
        setIdSendFile(ID)
    }
    const handleCloseModal = () => {
        setOpenModal(false);
        setErrorSend([{ Msg: '' }]);
        setSuccess(false);
        setIdSendFile('');
        setIsLoadingSend(false);
    }

    const validateForm = async (formData: any) => {
        try {
            await validationSchema.validate(formData, { abortEarly: false });
            return null;
        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const errors: { [key: string]: string } = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        errors[error.path] = error.message;
                    }
                });
                return errors;
            }
            return null;
        }
    };


    const handleAccept = async () => {
        const validationErrors = await validateForm(formData);

        if (validationErrors) {
            setErrors(validationErrors);
            return;
        }
        if (!errors.Email) {
            setIsLoadingSend(true);
            try {
                const response = await getRequest({
                    GuaranteeLetterID: idSendFile,
                    Email: formData.Email
                }, 'dms-hr', 'sendGuaranteeLetter', 'POST');
                const result = await response.json();
                if (result.Errors.length > 0) {
                    setErrorSend(result.Errors);
                } else {
                    setErrorSend([{ Msg: '' }]);
                    setSuccess(true);
                    setIsLoadingSend(true);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoadingSend(false);
            }
        } else {
            setErrors({ Email: errors.Email });
        }
        // setOpenModal(false);
        setFormData((prev: any) => ({
            ...prev,
            Email: ''
        }));
    };

    const FileData = useAppSelector(FileDataGuaranteeLetter);
    const FileName = useAppSelector(FileNameGuaranteeLetter);
    const [fileAction, setFileAction] = useState<{ action: 'open' | 'download' | null; id: string }>({ action: null, id: '' });



    // Функция для открытия файла
    const getOpenFile = (ID: string) => {
        setFileAction({ action: 'open', id: ID });
        dispatch(fetchDownloadhGuaranteeLetter({ GuaranteeLetterID: ID }));
    };

    // Функция для скачивания файла
    const getDownloadFile = (ID: string) => {
        setFileAction({ action: 'download', id: ID });
        dispatch(fetchDownloadhGuaranteeLetter({ GuaranteeLetterID: ID }));
    };

    // Эффект для обработки изменений FileData и FileName
    useEffect(() => {
        if (FileData && FileName && fileAction.action) {
            try {
                const byteCharacters = atob(FileData);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                if (fileAction.action === 'open') {
                    window.open(url, '_blank');
                } else if (fileAction.action === 'download') {
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = FileName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }

                URL.revokeObjectURL(url);
                dispatch(resetFile());
                setFileAction({ action: null, id: '' });
            } catch (error) {
                console.error(`Ошибка при ${fileAction.action === 'open' ? 'открытии' : 'скачивании'} файла:`, error);
            }
        }
    }, [FileData, FileName, fileAction, dispatch]);


    return (
        <>
            {isLoading && (
                <Loader
                    title='Загрузка...'
                />
            )}
            {!isLoading && (
                <>
                    <Box>
                        <ModalWidget
                            open={openModal}
                            handleClose={handleCloseModal}
                            title="Отправка ГП на почту"
                            closeIconPosition="right"
                        >
                            {isLoadingSend && <Loader
                                title='Отправка...'
                            />}
                            {success && <Box className={styles.successText}>
                                <p>ГП отправленно на почту</p>
                            </Box>}
                            {errorSend[0].Msg && (
                                <p className={styles.errorText}>{errorSend[0].Msg}</p>
                            )}
                            {!isLoadingSend && !errorSend[0].Msg && !success && (
                                <>
                                    <TextField
                                        label="Введите почту"
                                        value={formData.Email}
                                        name="Email"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChangeInput({ event })}
                                        onBlur={(event: React.FocusEvent<HTMLInputElement>) =>
                                            handleBlurInput(event)
                                        }
                                        variant="outlined"
                                        error={!!errors.Email}
                                        helperText={errors.Email || ''}
                                        className={styles.inputEmail}
                                    />
                                    <Box className={styles.btnSend}>
                                        <CustomButton
                                            title="Отправить"
                                            handleClick={handleAccept}
                                            textColor="white"
                                            backgroundColor="#326CFD"
                                            width="250px"
                                            gap="10px"
                                            borderRadius='4px'
                                            padding='3px'
                                        />
                                    </Box>
                                </>
                            )}
                        </ModalWidget>
                        {guaranteeLetter.length > 0 ? (
                            <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
                                <List
                                    title={['Дата', 'Статус ГП', 'Тип обращения', 'ЛПУ', 'Действия']}
                                    data={paginatedData()}
                                    renderItem={(item: any) => (
                                        <>
                                            <Box><p>{item.Date}</p></Box>
                                            <Box><p>{item.StatusName}</p></Box>
                                            <Box><p>{item.RequestTypeName}</p></Box>
                                            <Box><p>{item.HospitalFullName}</p></Box>
                                            <Box>
                                                <span onClick={() => getOpenFile(item.ID)} className={styles.iconAction}><VisibilityIcon /></span>
                                                <span onClick={() => getDownloadFile(item.ID)} className={styles.iconAction}><FileDownloadIcon /></span>
                                                <span onClick={() => getSendFile(item.ID)} className={styles.iconAction}><EmailIcon /></span>
                                            </Box>
                                        </>
                                    )}
                                    renderPagination={guaranteeLetter.length > 10}
                                    pageCount={Math.ceil(guaranteeLetter.length / 10)}
                                    onAction={handleChildAction}
                                    currentPage={currentPageInCase}
                                    link={false}
                                />
                            </Box>
                        ) : (
                            <Box className={appStyles.infoBox}>
                                <p>Гарантийные письма не найдены</p>
                            </Box>
                        )}
                    </Box>

                </>
            )}

        </>
    );

};

export default GuaranteeLetter;
